module.exports = __webpack_public_path__ + "static/media/carta_44.c442f99e.jpg";